// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__kaVUA","dot_spinner":"Loading_dot_spinner__WGm5A","dot_spinner__dot":"Loading_dot_spinner__dot__yMCun","pulse0112":"Loading_pulse0112__dtXT0"};